import React, { useState } from "react";
import {
  ageBracket,
  bandAus,
  cupSize,
  exerciseIntensity,
  region as regionList,
  cropTopSize,
  braTypeSelection
} from "../constants/formUtils";

export const WizardContext = React.createContext();

export const WizardProvider = ({ children }) => {
  const getSessionStorageOrDefault = (key, defaultValue) => {
    const stored = sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    console.log(typeof stored, stored, key, defaultValue);
    return JSON.parse(stored);
  };

  const [currentStep, setCurrentStep] = useState(
    getSessionStorageOrDefault("currentStep", 0)
  );
  const [age, setAge] = useState(
    getSessionStorageOrDefault("age", ageBracket[0])
  );
  const [cup, setCup] = useState(getSessionStorageOrDefault("cup", cupSize[2]));
  const [band, setBand] = useState(
    getSessionStorageOrDefault("band", bandAus[2])
  );
  const [intensity, setIntensity] = useState(
    getSessionStorageOrDefault("intensity", exerciseIntensity[0])
  );
  const [region, setRegion] = useState(
    getSessionStorageOrDefault("region", regionList[0])
  );
  const [selectedCropTopSize, setSelectedCropTopSize] = useState(
    getSessionStorageOrDefault("selectedCropTopSize", cropTopSize[1])
  );
  const [braType, setBraType] = useState(
    getSessionStorageOrDefault("braType", braTypeSelection[1])
  );

  React.useEffect(() => {
    sessionStorage.setItem(
      "selectedCropTopSize",
      JSON.stringify(selectedCropTopSize)
    );
  }, [selectedCropTopSize]);
  React.useEffect(() => {
    sessionStorage.setItem("region", JSON.stringify(region));
  }, [region]);
  React.useEffect(() => {
    sessionStorage.setItem("cup", JSON.stringify(cup));
  }, [cup]);
  React.useEffect(() => {
    sessionStorage.setItem("band", JSON.stringify(band));
  }, [band]);
  React.useEffect(() => {
    sessionStorage.setItem("braType", JSON.stringify(braType));
  }, [braType]);

  const wizardState = {
    currentStep,
    age,
    cup,
    intensity,
    band,
    region,
    selectedCropTopSize,
    braType,
    setCurrentStep,
    setAge,
    setCup,
    setIntensity,
    setBand,
    setRegion,
    setSelectedCropTopSize,
    setBraType,
  };

  return (
    <WizardContext.Provider value={wizardState}>
      {children}
    </WizardContext.Provider>
  );
};

export const useWizardContextState = () => {
  const context = React.useContext(WizardContext);

  if (context === undefined) {
    throw new Error("useWizardContextState must be within a RouteProvider");
  }
  return context;
};
